import { Routes } from '@angular/router';
import { LoginPage } from './shared/pages/login/login.page';
import { AccueilPage } from './shared/pages/accueil/accueil.page';
import { isAuthenticated } from './shared/guards/auth.guard';
import { accueilGuard } from './shared/guards/accueil.guard';
import { LoadingPage } from './shared/pages/loading/loading.page';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: AccueilPage,
    canActivate: [isAuthenticated, accueilGuard],
    canMatch: [isAuthenticated, accueilGuard],
  },
  {
    path: 'login',
    component: LoginPage,
    pathMatch: 'full',
  },
  {
    path: 'loading',
    component: LoadingPage,
    pathMatch: 'full',
  },
  {
    path: 'shared',
    loadChildren: () => import('./shared/shared.routes').then((m) => m.routes),
  },
  {
    path: 'mnt',
    loadChildren: () => import('./mnt/mnt.routes').then((m) => m.routes),
  },
  {
    path: 'crt',
    loadChildren: () => import('./crt/crt.routes').then((m) => m.routes),
  },
  {
    path: 'iot',
    loadChildren: () => import('./iot/iot.routes').then((m) => m.routes),
  },
  {
    path: 'gestion-stocks',
    loadChildren: () => import('./gestion-stocks/gestion-stocks.routes').then((m) => m.routes),
  },
];
